module.exports = __webpack_public_path__ + "static/media/logo.7bc2d7a3.png";